import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {GameCenterHeaderConfig} from "./game-center-header-module.config";
import {GameCenterHeaderModuleState} from "./models/game-center-header-module.state";

export class GameCenterHeaderModuleStore extends BaseMobxStore {
  static injectables = [GameCenterHeaderConfig, GameCenterHeaderModuleState];
}

